import request from "@/utils/request";

const fetch = (downloadAppUrl) => request
  .get("/api/app_install_qr_code", { params: { target_url: downloadAppUrl } }); //eslint-disable-line camelcase

export default {
  fetch
};
